<template>
  <div class="wrapper wrapper_pc">
    <h2>業務內容</h2>
    <div class="con">
      <ul class="flexCenter">
        <li class="animate__animated animate__fadeInLeft">
          <img src="../../assets/imgs/barrageGame/1.png" alt="">
        </li>
        <li class="animate__animated animate__fadeInRight">
          <img src="../../assets/imgs/barrageGame/2.png" alt="">
        </li>
        <li class="animate__animated animate__fadeInLeft">
          <img src="../../assets/imgs/barrageGame/3.png" alt="">
        </li>
        <li class="animate__animated animate__fadeInRight">
          <img src="../../assets/imgs/barrageGame/4.png" alt="">
        </li>
      </ul>
      <p>
        加入 Morefun 公會，不只是加入一個團隊，更是開啟一段精彩的直播旅程。<br/>
        我們擁有專業的支援團隊、豐富的資源與靈活的合作模式，無論是全職還是兼職，公會都會根據主播的需求提供量身訂製的發展計劃。<br/>
        在 Morefun ，你的直播不僅是一份熱愛，更是一份有趣、有價值的事業！
      </p>
    </div>
  </div>
</template>

<script>

export default {
  name: "BusinessContent",
  data: function () {
    return {};
  }
};
</script>

<style lang="stylus" scoped>
.flexCenter{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.wrapper {
  width: 100%;
  background: #fff;

  h2 {
    color: #4b4a47;
    font-size: 47px;
    text-align: center;
    margin:106px 0 29px;
  }

  .con {
    width: 1367px;
    margin: 0 auto;
    text-align: center;
    ul{
      li{
        width: 669px;
        height: 461px;
        list-style-type: none;
        margin-bottom: 23px;
        overflow: hidden;
        border:3px solid #f0c015;
        &:hover{
          img{
            transform: scale(1.1);
          }
        }
        img{
          width: 100%;
          height: 100%;
          transition: all .9s;
        }
      }
    }
    p {
      color: #4b4a47;
      font-size: 20px;
      margin: 18px 0 175px;
    }
  }
}
</style>
